import React from 'react';
import styles from './FeatureNumberBlock.module.scss';
import RichTextRender from '../RichTextRender';
import Heading from '@src/elements/Heading';
import { FeatureNumberBlockFragment } from '@src/graphql/gql-types';
import MediaImage from '../MediaImage';
import { CONTENTFUL_PAGE_CONTENT_TYPES } from '@src/constants/contentful';
import { RICHTEXT_RENDER_MODE } from '@src/types/richText';
import CTAButton from '../Button/CTAButton';
import {
  COLOR_OUTERSPACE,
  ContentBlockBackgroundColors
} from '@src/types/colors';
import Visibility from '@src/elements/Visibility';
import { Column, Container, Row } from '@src/elements/Grid';
import { getColorClasses } from '@src/utils/colorClasses';
import classNames from 'classnames';

type FeatureNumberBlock = FeatureNumberBlockFragment & {
  backgroundColor?: ContentBlockBackgroundColors;
};

const FeatureNumberBlock: React.FC<FeatureNumberBlock> = ({
  heading,
  bodyContent,
  media,
  primaryCta,
  secondaryCta,
  backgroundColor
}) => {
  return (
    <div
      className={classNames(
        styles.featureNumberBlock,
        backgroundColor ? getColorClasses(backgroundColor, styles) : ''
      )}
    >
      <Container containerWidth="fluid">
        <Row>
          <Column xs={4} md={8} lg={7} xl={7}>
            <Heading priority={2} fontStyle="h1">
              {heading}
            </Heading>
            <div className={styles.featureNumberBodyContent}>
              {bodyContent && (
                <RichTextRender
                  pageType={CONTENTFUL_PAGE_CONTENT_TYPES.NATIONAL_STANDARD}
                  renderMode={RICHTEXT_RENDER_MODE.FEATURE_NUMBER_BLOCK}
                  bodyContent={bodyContent}
                />
              )}
            </div>
            <div className={styles.featureNumberCtaContainer}>
              {primaryCta && (
                <CTAButton
                  cta={primaryCta}
                  label={primaryCta.label || ''}
                  color={COLOR_OUTERSPACE}
                  fillVariant="filled"
                />
              )}
              {secondaryCta && (
                <CTAButton
                  cta={secondaryCta}
                  label={secondaryCta.label || ''}
                  color={COLOR_OUTERSPACE}
                  fillVariant="outline"
                />
              )}
            </div>
          </Column>
          <Column xs={4} md={8} xl={4} offsetXl={1}>
            <div className={styles.featureNumberMedia}>
              <Visibility xs={false} md={true}>
                {media && <MediaImage {...media} />}
              </Visibility>
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

export default FeatureNumberBlock;
